import { Dto } from '@core/data/dto/dto';
import { DTO_DEFAULT, DtoType } from '@core/data/dto/dto-types';
import { Entity } from '@core/data/dto/entity';
import { DtoExport, DtoImport } from '@core/utils/dto';
import { copyObjectProperties } from '@core/utils/object';
import { TipSourceTipTypeSchema } from './tip-source-tip-type.schema';

export class TipSourceTipType implements Entity {
    public id: string;
    public label: string;
    public labelKey: string;
    public payViaPayroll: boolean;

    constructor(value?: any) {
        if (value) {
            copyObjectProperties.call(this, value);
        }
    }

    @DtoImport(TipSourceTipTypeSchema)
    static import(dto: Dto): any {
        return new TipSourceTipType(dto);
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: TipSourceTipTypeSchema,
        },
    ])
    export(type?: DtoType): any {}
}
